import { useEffect } from 'react'

import BillingActive from 'assets/switch/active/Billing.svg'
import BillingDeactivated from 'assets/switch/deactivated/Billing.svg'

import ServiceActive from 'assets/switch/active/Service.svg'
import ServiceDeactivated from 'assets/switch/deactivated/Service.svg'

import AccountStatusActive from 'assets/switch/active/AccountStatus.svg'
import AccountStatusDeactivated from 'assets/switch/deactivated/AccountStatus.svg'

import PropertyOwnerActive from 'assets/switch/active/PropertyOwner.svg'
import PropertyOwnerDeactivated from 'assets/switch/deactivated/PropertyOwner.svg'

import UnscheduledActive from 'assets/switch/active/Unscheduled.svg'
import UnscheduledDeactivated from 'assets/switch/deactivated/Unscheduled.svg'

import TemporaryModeActive from 'assets/switch/active/TemporaryMode.svg'
import TemporaryModeDeactivated from 'assets/switch/deactivated/TemporaryMode.svg'

import DriverPathActive from 'assets/switch/active/DriverPath.svg'
import DriverPathDeactivated from 'assets/switch/deactivated/DriverPath.svg'

import SequenceLineActive from 'assets/switch/active/SequenceLine.svg'
import SequenceLineDeactivated from 'assets/switch/deactivated/SequenceLine.svg'

import TagActive from 'assets/switch/active/Tag.svg'
import TagDeactivated from 'assets/switch/deactivated/Tag.svg'

import ActionActive from 'assets/switch/active/Action.svg'
import ActionDeactivated from 'assets/switch/deactivated/Action.svg'

import UnassignedActive from 'assets/switch/active/Unassigned.svg'
import UnassignedDeactivated from 'assets/switch/deactivated/Unassigned.svg'

import EndedStopActive from 'assets/switch/active/EndedStop.svg'
import EndedStopDeactivated from 'assets/switch/deactivated/EndedStop.svg'

import DeactivatedStopActive from 'assets/switch/active/DeactivatedStop.svg'
import DeactivatedStopDeactivated from 'assets/switch/deactivated/DeactivatedStop.svg'

const PreLoadImages = () => {
  useEffect(() => {
    ;[
      BillingActive,
      BillingDeactivated,
      ServiceActive,
      ServiceDeactivated,
      AccountStatusActive,
      AccountStatusDeactivated,
      PropertyOwnerActive,
      PropertyOwnerDeactivated,
      UnscheduledActive,
      UnscheduledDeactivated,
      TemporaryModeActive,
      TemporaryModeDeactivated,
      DriverPathActive,
      DriverPathDeactivated,
      SequenceLineActive,
      SequenceLineDeactivated,
      TagActive,
      TagDeactivated,
      ActionActive,
      ActionDeactivated,
      UnassignedActive,
      UnassignedDeactivated,
      EndedStopActive,
      EndedStopDeactivated,
      DeactivatedStopActive,
      DeactivatedStopDeactivated,
    ].forEach(image => {
      new Image().src = image
    })
  }, [])

  return null
}

export default PreLoadImages
